import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom"; // Adicione isso
import { MdSpeed } from "react-icons/md";
import { BiGasPump } from "react-icons/bi";
import { FaRegCalendar, FaSearch } from "react-icons/fa";
import { FiEye } from "react-icons/fi";
import { LuMessageCircle } from "react-icons/lu";
import { retiraMascara } from "../utils/retiraMascara";
import { formatMoney } from "../utils/formatMoney";
import Header from "../components/Header";
import Footer from "../components/Footer";
import FiltrosAvancados from "../components/FiltrosAvancados";
import { firestore } from "../firebase-config";
import { id_firebase } from "../content-site";
import { collection, doc, query, where, orderBy, onSnapshot } from "firebase/firestore";

export default function Estoque() {
    const [veiculos, setVeiculos] = useState([]);
    const [revenda, setRevenda] = useState([]);
    const [filtros, setFiltros] = useState({ marca: "", modelo: "", ano: "" });
    const [filtrosAvancados, setFiltrosAvancados] = useState({ tipo: "", cor: "", portas: "", kmMax: "", precoMin: "", precoMax: "", blindado: "" });
    const [filtrosAplicados, setFiltrosAplicados] = useState({ ...filtros, ...filtrosAvancados });
    const [ordenarPor, setOrdenarPor] = useState("relevancia");
    const [paginaAtual, setPaginaAtual] = useState(1);
    const [, setErroFiltro] = useState("");
    const veiculosPorPagina = 9;
    const location = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);

        import("firebase/firestore").then(({ getDoc }) => {
            const revendaRef = doc(collection(firestore, "revenda"), id_firebase);
            getDoc(revendaRef).then((docSnap) => {
                if (docSnap.exists()) {
                    setRevenda(docSnap.data());
                }
            });
        });

        const q = query(
            collection(doc(collection(firestore, "revenda"), id_firebase), "veiculos"),
            where("veremovido", "==", 0),
            where("vevendido", "==", 0),
            orderBy("updated_at", "desc")
        );

        const unsubscribe = onSnapshot(q, (querySnapshot) => {
            const items = [];
            querySnapshot.forEach((doc) => {
                const document = doc.data();
                document.id = doc.id;
                if (document.veexibir_site !== false) {
                    items.push(document);
                }
            });
            setVeiculos(items);
        });

        return () => unsubscribe();
    }, []);

    // Adicione este useEffect para ler os filtros da URL ao montar
    useEffect(() => {
        const params = new URLSearchParams(location.search);

        // Filtros principais
        const marca = params.get("vefipe_marca") || "";
        const modelo = params.get("vefipe_name") || "";
        const ano = params.get("vefipe_ano_modelo") || "";

        // Filtros avançados
        const tipo = params.get("tipo") || "";
        const cor = params.get("cor") || "";
        const portas = params.get("portas") || "";
        const kmMax = params.get("kmMax") || "";
        const precoMin = params.get("precoMin") || "";
        const precoMax = params.get("precoMax") || "";
        const blindado = params.get("blindado") || "";

        setFiltros({ marca, modelo, ano });
        setFiltrosAvancados({ tipo, cor, portas, kmMax, precoMin, precoMax, blindado });
        setFiltrosAplicados({ marca, modelo, ano, tipo, cor, portas, kmMax, precoMin, precoMax, blindado });
    }, [location.search]);

    const handleBuscar = () => {
        setFiltrosAplicados({ ...filtros, ...filtrosAvancados });
    };

    const veiculosFiltrados = veiculos.filter(v => {
        return (
            (!filtrosAplicados.marca || v.vefipe_marca === filtrosAplicados.marca) &&
            (!filtrosAplicados.modelo || v.vefipe_name === filtrosAplicados.modelo) &&
            (!filtrosAplicados.ano || v.vefipe_ano_modelo === filtrosAplicados.ano) &&
            (!filtrosAplicados.tipo || v.vecarroceria === filtrosAplicados.tipo) &&
            (!filtrosAplicados.cor || v.vecor === filtrosAplicados.cor) &&
            (!filtrosAplicados.portas || v.veportas === filtrosAplicados.portas) &&
            (!filtrosAplicados.kmMax || v.vequilometragem <= Number(filtrosAplicados.kmMax)) &&
            (!filtrosAplicados.precoMin || v.vevalor >= Number(filtrosAplicados.precoMin)) &&
            (!filtrosAplicados.precoMax || v.vevalor <= Number(filtrosAplicados.precoMax)) &&
            (!filtrosAplicados.blindado || v.veblindado === (filtrosAplicados.blindado === 'true'))
        );
    });

    const getOpcoesFiltro = (campo, marcaSelecionada = "") => {
        const modelosFiltrados = veiculos.filter(v => campo !== "vefipe_name" || v.vefipe_marca === marcaSelecionada);
        const opcoes = modelosFiltrados.map(v => v[campo]).filter((valor, i, self) => valor && self.indexOf(valor) === i);
        return opcoes.sort();
    };

    const ordenarVeiculos = (lista) => {
        switch (ordenarPor) {
            case "menor_preco": return [...lista].sort((a, b) => a.vevalor - b.vevalor);
            case "maior_preco": return [...lista].sort((a, b) => b.vevalor - a.vevalor);
            case "menor_km": return [...lista].sort((a, b) => a.vequilometragem - b.vequilometragem);
            case "marca_az": return [...lista].sort((a, b) => a.vefipe_marca.localeCompare(b.vefipe_marca));
            default: return lista;
        }
    };

    const veiculosFiltradosOrdenados = ordenarVeiculos(veiculosFiltrados);
    const totalPaginas = Math.ceil(veiculosFiltradosOrdenados.length / veiculosPorPagina);
    const indiceInicial = (paginaAtual - 1) * veiculosPorPagina;
    const indiceFinal = indiceInicial + veiculosPorPagina;
    const veiculosPaginados = veiculosFiltradosOrdenados.slice(indiceInicial, indiceFinal);

    useEffect(() => {
        setPaginaAtual(1);
    }, [filtrosAplicados, ordenarPor]);

    return (
        <div>
            <Header />

            {/* Conteúdo semelhante ao Next.js, removido uso de Image do next/image */}
            <div className="relative h-[350px] w-full">
                <img
                    src="/banner.png"
                    alt="Banner da Moema Motors"
                    className="object-cover w-full h-full"
                />

                <div className="absolute inset-0 bg-black/50" />
                <div className="absolute inset-0 flex flex-col items-center justify-center text-white text-center px-4 z-10 mt-18">
                    <h1 className="text-6xl font-bold">Nosso Estoque</h1>
                    <p className="text-lg font-semibold mt-2">Explore nossa seleção completa de veículos premium</p>
                </div>
            </div>
            <div className="flex justify-center items-center w-full mt-10 mb-8">
                <div className="bg-white rounded-xl flex flex-col justify-center gap-2 md:gap-4 p-6 shadow-lg w-full max-w-3xl">
                    <h2 className="font-bold text-2xl text-center text-neutral-800">Encontre seu veículo ideal</h2>
                    <div className="flex flex-col md:flex-row gap-2 md:gap-4 items-center">
                        <select
                            className="p-2 rounded-md border border-gray-300 text-black w-full md:w-1/3"
                            value={filtros.marca}
                            onChange={e => {
                                setFiltros(f => ({ ...f, marca: e.target.value }));
                                setErroFiltro("");
                            }}
                        >
                            <option value="">Marca</option>
                            {getOpcoesFiltro("vefipe_marca").map(marca => (
                                <option key={marca} value={marca}>{marca}</option>
                            ))}
                        </select>

                        <div className="relative w-full md:w-1/3">
                            <select
                                className="p-2 rounded-md border border-gray-300 text-black w-full"
                                value={filtros.modelo}
                                onChange={e => setFiltros(f => ({ ...f, modelo: e.target.value, ano: "" }))}
                            >
                                <option value="">Modelo</option>
                                {getOpcoesFiltro("vefipe_name", filtros.marca)
                                    .map(modelo => (
                                        <option key={modelo} value={modelo}>{modelo}</option>
                                    ))}
                            </select>
                        </div>

                        <div className="relative w-full md:w-1/3">
                            <select
                                className="p-2 rounded-md border border-gray-300 text-black w-full"
                                value={filtros.ano}
                                onChange={e => setFiltros(f => ({ ...f, ano: e.target.value }))}
                            >
                                <option value="">Ano</option>
                                {getOpcoesFiltro("vefipe_ano_modelo")
                                    .map(ano => (
                                        <option key={ano} value={ano}>{ano}</option>
                                    ))}
                            </select>
                        </div>

                        {(filtros.marca || filtros.modelo || filtros.ano) && (
                            <button
                                className="bg-gray-200 text-gray-700 px-4 py-2 rounded-md font-semibold whitespace-nowrap"
                                type="button"
                                onClick={() => {
                                    setFiltros({ marca: "", modelo: "", ano: "" });
                                    setErroFiltro("");
                                }}
                            >
                                Limpar filtros
                            </button>
                        )}

                        <button
                            className="flex items-center gap-2 bg-red-900 text-white px-4 py-2 rounded-md w-full md:w-auto"
                            onClick={handleBuscar}
                            type="button"
                        >
                            <FaSearch /> Buscar
                        </button>
                    </div>
                    <div className="flex justify-center mt-4">
                        <div>
                            <FiltrosAvancados
                                filtros={filtrosAvancados}
                                setFiltros={setFiltrosAvancados}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className="max-w-6xl mx-auto px-4 flex flex-col md:flex-row justify-between items-center mt-4 text-sm text-gray-700">
                <span>
                    Mostrando {veiculosFiltradosOrdenados.length > 0 ? `${indiceInicial + 1}-${Math.min(indiceFinal, veiculosFiltradosOrdenados.length)}` : "0"} de {veiculosFiltradosOrdenados.length} veículos
                </span>

                <div className="flex items-center mt-2 md:mt-0 gap-2">
                    <span className="font-medium">Ordenar por:</span>
                    <select
                        className="border border-gray-300 rounded-md p-2"
                        value={ordenarPor}
                        onChange={(e) => setOrdenarPor(e.target.value)}
                    >
                        <option value="relevancia">Relevância</option>
                        <option value="menor_preco">Menor preço</option>
                        <option value="maior_preco">Maior preço</option>
                        <option value="menor_km">Menor KM</option>
                        <option value="marca_az">Marca A-Z</option>
                    </select>
                </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-8 px-4 max-w-6xl mx-auto">
                {veiculosPaginados.length === 0 && (
                    <div className="col-span-full text-center text-gray-500 py-12">
                        Nenhum veículo encontrado com os filtros selecionados.
                    </div>
                )}
                {veiculosPaginados.map(veiculo => (
                    <div key={veiculo.id} className="bg-white rounded-xl shadow-lg overflow-hidden flex flex-col">
                        <div className="relative">
                            <img
                                src={veiculo.imagens[0].fileUrl}
                                alt={veiculo.titulo}
                            />

                            <div className="absolute bottom-2 left-2 bg-white text-red-700 font-bold text-lg px-4 py-1 rounded shadow">
                                {formatMoney(veiculo.vevalor)}
                            </div>
                        </div>

                        <div className="p-4 flex-1 flex flex-col justify-between">
                            <h3 className="text-lg font-bold mb-1 uppercase leading-snug">
                                {veiculo.vefipe_marca + " " + veiculo.vefipe_name}
                            </h3>

                            <div className="flex items-center text-sm text-gray-600 gap-4 mt-2">
                                <span className="flex items-center gap-1">
                                    <MdSpeed /> {veiculo.vequilometragem}km
                                </span>
                                <span className="flex items-center gap-1">
                                    <BiGasPump /> {veiculo.vefipe_combustivel}
                                </span>
                                <span className="flex items-center gap-1">
                                    <FaRegCalendar /> {veiculo.veano_fabricacao} / {veiculo.vefipe_ano_modelo}
                                </span>
                            </div>
                            <div>
                                <p className="text-xl font-bold mt-2">
                                    {veiculo.vevalor ? formatMoney(veiculo.vevalor) : "Consulte o preço"}
                                </p>
                            </div>

                            <div className="flex items-center justify-center gap-4 p-2 mt-4">
                                <a href={`/veiculo/${veiculo.id}`} className="w-full">
                                    <button className="w-full bg-red-700 hover:bg-red-800 text-white font-semibold py-2 rounded flex items-center justify-center gap-2">
                                        <FiEye />
                                        Ver Detalhes
                                    </button>
                                </a>
                                <a
                                    href={
                                        'https://api.whatsapp.com/send?phone=55' + retiraMascara(revenda.petelefone2, "link")
                                    }
                                    className="border border-gray-300 text-red-700 font-bold p-3 rounded-md flex items-center justify-center"
                                    target="_blank" rel="noopener noreferrer"
                                >
                                    <LuMessageCircle />
                                </a>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {totalPaginas > 1 && (
                <div className="flex justify-center items-center gap-2 mt-8 mb-12">
                    <button
                        className="px-3 py-1 rounded border border-gray-300 bg-white disabled:opacity-50"
                        onClick={() => setPaginaAtual(p => Math.max(1, p - 1))}
                        disabled={paginaAtual === 1}
                    >
                        Anterior
                    </button>
                    {[paginaAtual, paginaAtual + 1]
                        .filter(p => p <= totalPaginas)
                        .map(p => (
                            <button
                                key={p}
                                className={`px-3 py-1 rounded border border-gray-300 ${paginaAtual === p ? "bg-red-700 text-white font-bold" : "bg-white"}`}
                                onClick={() => setPaginaAtual(p)}
                            >
                                {p}
                            </button>
                        ))}
                    {paginaAtual + 1 < totalPaginas && (
                        <button
                            className="px-3 py-1 rounded border border-gray-300 bg-white"
                            onClick={() => setPaginaAtual(paginaAtual + 2)}
                        >
                            {paginaAtual + 2}
                        </button>
                    )}
                    <button
                        className="px-3 py-1 rounded border border-gray-300 bg-white disabled:opacity-50"
                        onClick={() => setPaginaAtual(p => Math.min(totalPaginas, p + 1))}
                        disabled={paginaAtual === totalPaginas}
                    >
                        Próxima
                    </button>
                </div>
            )}

            <Footer />
        </div>
    );
}